import React from 'react';
import classes from "./ProcessSubtitle.module.css";

export default function ProcessSubtitle() {
  return (
    <div className={classes.subtitle}>
      <h3>is organized</h3>
      <div className={classes.frame}>
        <svg width="186" height="271" viewBox="0 0 186 271" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 44.4497C42.26 59.1097 73.59 96.0299 81.51 138.14C89.43 180.25 73.6299 226.02 41.4299 254.29" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M35.27 248.26C35.786 255.318 34.6741 262.4 32.02 268.96C38.3917 262.47 46.458 257.9 55.3 255.77" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M16 6.75983C74.24 -9.05017 139.3 15.65 167.78 64.4C196.26 113.15 185.69 181.74 143.15 224.4" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M137.49 217.18C138.005 224.234 136.894 231.313 134.24 237.87C140.612 231.38 148.678 226.81 157.52 224.68" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  )
}
